import api from 'api';
import storage from "@/cflow/storageService";

class FinanceiroService {

    listar(ano, mes) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            mes = mes + 1; //js pattern to php pattern
            api.get('/financeiro?ano='+ano+'&mes='+mes+'&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/financeiro/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/financeiro/' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new FinanceiroService();